import Emitter from '../Emitter';
import Commander from "../Commander";
import * as PIXI from "pixi.js-legacy";

class NormalWin {
    constructor(commander) {
        this.commander = commander;
        this.SymbolAnimations = this.commander.SymbolAnimations;
        this.LineWinAnimations = this.commander.LineWinAnimations;
        this.Emitter = this.commander.Emitter;
        this.WinLines = this.commander.WinLines;
        this.layer = {
            reels: this.commander.layers.reels,
            beam: this.commander.layers.win.children[0],
            wild: this.commander.layers.win.children[1],
            anim: this.commander.layers.win.children[2],
            particles: this.commander.layers.win.children[3],
            numbers: this.commander.layers.win.children[4]
        };
    }

    init() {

    }

    async run(lineWins, bigwin = false) {
        for (let lineWin of lineWins) {
            if (!this.commander.skipAnim) {
                if (!bigwin)
                    this.commander.addWin(lineWin.win);
                this.LineWinAnimations.run(lineWin);
                this.Emitter.emitLine(lineWin.line + 1, Emitter.getDirection(lineWin), lineWin.position.length);
                for (let pos of lineWin.position) {
                    let symbol = this.commander.slots.getResultSymbols()[pos[0] * 3 + pos[1]];
                    await this.SymbolAnimations.run(symbol);
                }
                if (lineWin.position.length < 5)
                    await this.SymbolAnimations.delay(5 - lineWin.position.length);
            }
            this.commander.lineWinsIndex++;
        }
    }

    setColor(text, name) {
        switch(name) {
            case "symbol_crystal_yellow":
            case "symbol_crystal_bar":
                this.commander.animColorFilter.hue(58-39, false);
                break;
            case "symbol_crystal_purple":
                this.commander.animColorFilter.hue(276-39, false);
                break;
            case "symbol_crystal_blue":
                this.commander.animColorFilter.hue(184-39, false);
                break;
            case "symbol_crystal_green":
                this.commander.animColorFilter.hue(85-39, false);
                break;
            case "symbol_crystal_seven":
                this.commander.animColorFilter.hue(356-39, false);
                break;
            case "symbol_crystal_orange":
                this.commander.animColorFilter.hue(0, false);
                break;
        }
    }
}
export default NormalWin;
